import { GetCheckRequestsProps } from "@/services/check-requests.service";
import dayjs, { Dayjs } from "dayjs";

export interface CRFRProps {
  request_date?: Dayjs;
  account_owner: string;
  sucursal: number[];
  request_amount: string;
  requester: string;
  request_type: string[];
  account_number: string;
  estado?: string[];
}

export const getCheckRequestFilter = (
  event: CRFRProps,
): Partial<GetCheckRequestsProps> => {
  let amount;

  if (event?.request_amount) {
    const cleaned = event?.request_amount
      .replaceAll(/[^0-9,.-]/g, "")
      .replaceAll(".", "")
      .replaceAll(",", ".");

    amount = Number.parseFloat(cleaned).toFixed(2);
  }

  return {
    ...(event?.estado?.length
      ? {
          estado: event?.estado,
        }
      : {}),
    ...(event?.request_date && dayjs(event?.request_date).isValid()
      ? {
          fechaDesde: dayjs(event?.request_date).toISOString(),
        }
      : {}),
    ...(event?.account_owner
      ? {
          Titular: event?.account_owner,
        }
      : {}),
    ...(event?.account_number
      ? {
          NroCuenta: event?.account_number,
        }
      : {}),
    ...(event?.request_type?.length
      ? {
          TipoSolicitud: event?.request_type?.[0],
        }
      : {}),
    ...(event?.sucursal?.length
      ? {
          ClaveSucursal: event?.sucursal?.map(String),
        }
      : {}),
    ...(event?.request_amount && amount
      ? {
          monto: amount,
        }
      : {}),
    ...(event?.requester
      ? {
          Solicitante: event?.requester,
        }
      : {}),
  };
};
